import { lazy } from "react";

export const LazyAuthRouter = lazy(() => import("modules/Auth/AuthRouter"));
export const LazyAdminRouter = lazy(() => import("modules/Admin/AdminRouter"));
export const LazySuperAdminRouter = lazy(() => import("modules/SuperAdmin/SuperAdminRouter"));
export const LazyMainLayout = lazy(() => import("shared/layouts/Main"));
export const LazyNotFound = lazy(() => import("shared/components/NotFound"));
